import { HTMLAttributes, ReactNode } from 'react';
import classnames from 'src/util/classnames';

interface CollapseProps extends HTMLAttributes<HTMLDivElement> {
  isOpen?: boolean;
  navbar?: boolean;
  children?: ReactNode;
}

export function Collapse({ isOpen, navbar, className, children, ...props }: CollapseProps) {
  return (
    <div className={classnames('collapse', navbar && 'navbar-collapse', isOpen && 'show', className)} {...props}>
      {children}
    </div>
  );
}
